<div class="backdrop">
  <div class="pic"></div>
  <div class="form" *ngIf="!isMfaTokenVisible">
    <app-login-form [loginFailed]="loginFailed" (submitted)="onSubmit($event)" [isBusy]="isBusy"></app-login-form>
  </div>
  <div class="form" *ngIf="isMfaTokenVisible">
    <app-login-mfa
      [loginFailed]="loginFailed"
      [triesCount]="loginFailCount"
      [isBusy]="isBusy"
      [mfaToken]="mfaToken"
      (submitted)="onSubmitMfa($event)"
    ></app-login-mfa>
  </div>
</div>
